import PropTypes from 'prop-types';
import React from 'react';
import { injectIntl } from 'react-intl';
import { useNavigate } from 'react-router';
import styled from 'styled-components';
import { withShadow } from 'ui/styles';
import { Flex, Icon } from 'ui';
import { getValueAndPostfix } from 'utils/helpers';

const Kpis = styled(Flex)`
  flex-wrap: wrap;
  justify-content: flex-start;
`;

const Item = styled(Flex)`
  ${withShadow};
  align-items: center;
  border-radius: 4px;
  background-color: #fff;
  padding: 2px;
  margin: 0 10px 10px 0;
  width: 210px;
  height: 80px;
  ${p => p.clickThrough && 'cursor: pointer;'};
  ${p => !p.clickThrough && 'padding-right: 10px;'};
  justify-content: space-around;
`;

const Value = styled.div`
  font-weight: ${p => p.theme.fontWeight.bold};
  color: ${p => p.theme.colors.theme};
  font-size: ${p => p.large ? '2.5rem' : '1.4rem'};
  padding: 0 0.2em;
`;

const Label = styled(Flex)`
  overflow-wrap: break-word;
  word-break: break-word;
  overflow: hidden;
  font-weight: ${p => p.theme.fontWeight.normal};
`;

const KPI = ({ kpis, intl }) => {
  const navigate = useNavigate();

  const navigateTo = (kpi) => {
    if (kpi.clickThrough) {
      navigate(`../${kpi.uri}`, { push: true, context: kpi.filter });
    }
  };

  return (
    <Kpis>
      {kpis?.map((kpi, i) => {
        const { value, postfix } = getValueAndPostfix(kpi.value);
        let uom = '';
        let tooltip = '';

        const translatedLabel = `${kpi.labelTranslationKey
          ? intl.formatMessage({ id: kpi.labelTranslationKey })
          : ''
          }`;

        const formattedValue = `${intl.formatNumber(value)}${postfix}`;

        if (kpi.unitTranslationKey) {
          uom = intl.formatMessage({ id: kpi.unitTranslationKey });
        } else if (kpi.currencyCode) {
          uom = kpi.currencyCode;
          const currencyLongText = intl.formatMessage({
            id: kpi.currencyTranslationKey,
          });
          tooltip = `${formattedValue} ${currencyLongText} ${translatedLabel}`;
        }

        return (
          <Item
            data-test-id={kpi.labelTranslationKey}
            clickThrough={kpi.clickThrough}
            onClick={() => navigateTo(kpi)}
            key={i}
          >
            <Value large>{formattedValue}</Value>
            <Label title={tooltip}>{`${uom} ${translatedLabel}`}</Label>
            {kpi.clickThrough &&
              <Value>
                <Icon type='angle-right' />
              </Value>
            }
          </Item>
        );
      })}
    </Kpis>
  );
};

KPI.propTypes = {
  kpis: PropTypes.array.isRequired,
  intl: PropTypes.object,
};

export default injectIntl(KPI);
